import { model as person } from './person'
import { model as assessment } from './assessment'
import { model as error } from './error'
import { model as group } from './group'
import { model as user } from './user'
import { model as organization } from './organization'
import { model as cseit } from './cseit'
import { model as laborScreening } from './laborScreening'
import { model as victimInfo } from './victimInfo'
import { model as oldTraffickingScreening } from './oldTraffickingScreening'
import { model as traffickingScreening } from './traffickingScreening'

export {
  person,
  assessment,
  error,
  group,
  user,
  organization,
  cseit,
  laborScreening,
  oldTraffickingScreening,
  traffickingScreening,
  victimInfo
}



// WEBPACK FOOTER //
// ./src/api/models/index.js